import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=0d50b4b1&scoped=true&"
import script from "./BackOffice.vue?vue&type=script&lang=js&"
export * from "./BackOffice.vue?vue&type=script&lang=js&"
import style0 from "./BackOffice.vue?vue&type=style&index=0&id=0d50b4b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50b4b1",
  null
  
)

export default component.exports